import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { RotateCcw } from 'lucide-react';

interface RetryDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  onConfirm: () => void;
}

export const RetryDialog: React.FC<RetryDialogProps> = ({ open, onOpenChange, count, onConfirm }) => {
  const isBulk = count > 1;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {isBulk ? `Retry ${count} Failed Lines` : 'Retry Posting'}
          </DialogTitle>
          <DialogDescription>
            {isBulk
              ? `Retry ${count} failed lines? This will resend them to the ERP sequentially.`
              : 'Retry posting this line to the ERP? This will attempt to resend the transaction.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              onConfirm();
            }}
          >
            <RotateCcw className="h-4 w-4 mr-1.5" />
            {isBulk ? `Retry ${count} Lines` : 'Retry'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
